import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      document.querySelectorAll( '.logo-spinner__spinning-text' ).forEach( ( el ) => {
        gsap.to( el, {
          rotation: 360,
          ease: 'none',
          transformOrigin: '50% 50%',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'logo-spinner', COMPONENT );
} )( app );
